<template>
  <div class="page">
    <div class="page-head">
      <h3>지사 조회</h3>
      <div class="head-btns">
        <button class="primary" @click="openAdd">추가</button>
        <button class="ghost" :disabled="!selected" @click="openEdit">수정</button>
      </div>
    </div>

    <div class="toolbar">
      <label>센터명</label>
      <input v-model="centerName" type="text" placeholder="센터명" @keyup.enter="reload" />
      <button class="srch" @click="centerSearchOpen=true">검색</button>
      <label>지사명</label>
      <input v-model="branchName" type="text" placeholder="지사명" @keyup.enter="reload" />
      <label>지사장</label>
      <input v-model="leaderName" type="text" placeholder="지사장" @keyup.enter="reload" />
      <label>사용여부</label>
      <select v-model="useYn">
        <option value="">전체</option>
        <option value="Y">Y</option>
        <option value="N">N</option>
      </select>
      <button @click="reload">조회</button>
    </div>

    <div class="table-scroll">
      <table class="grid">
        <thead>
          <tr><th class="c">선택</th><th>센터명</th><th>센터장</th><th>지사명</th><th>지사장</th><th>사용여부</th></tr>
        </thead>
        <tbody>
          <tr v-for="r in rows" :key="r.id" :class="{sel: selected && selected.id===r.id}" @click="selected=r">
            <td class="c"><input type="radio" :checked="selected && selected.id===r.id" @change="selected=r" /></td>
            <td>{{ r.centerName || '-' }}</td>
            <td>{{ r.centerLeaderName || '-' }}</td>
            <td>{{ r.branchName }}</td>
            <td>{{ r.leaderName || '-' }}</td>
            <td>{{ r.useYn }}</td>
          </tr>
          <tr v-if="rows.length===0"><td colspan="6" class="empty">데이터가 없습니다.</td></tr>
        </tbody>
      </table>
    </div>

    <Paging :page="page" :size="size" :total-count="total" :total-pages="totalPages"
            @change-page="onPage" @change-size="onSize" />

    <BranchFormDialog v-if="formOpen" :mode="formMode" :branch="formBranch"
                      @saved="onSaved" @close="formOpen=false" />
    <!-- 검색조건의 센터명 검색 버튼 → 센터 검색 팝업 -->
    <SettlementCenterSearchDialog v-if="centerSearchOpen" @select="onPickCenter" @close="centerSearchOpen=false" />
  </div>
</template>

<script>
import api from '../api';
import Paging from '../components/Paging.vue';
import BranchFormDialog from '../components/BranchFormDialog.vue';
import SettlementCenterSearchDialog from '../components/SettlementCenterSearchDialog.vue';

export default {
  name: 'BranchAdmin',
  components: { Paging, BranchFormDialog, SettlementCenterSearchDialog },
  data() {
    return {
      centerName: '', branchName: '', leaderName: '', useYn: '',
      rows: [], selected: null,
      page: 1, size: 10, total: 0,
      formOpen: false, formMode: 'add', formBranch: null,
      centerSearchOpen: false
    };
  },
  computed: { totalPages() { return Math.max(1, Math.ceil(this.total / this.size)); } },
  created() { this.reload(); },
  methods: {
    async load() {
      try {
        const res = await api.branchAdminList({
          centerName: this.centerName, branchName: this.branchName, leaderName: this.leaderName,
          useYn: this.useYn, page: this.page, size: this.size
        });
        const d = res.data || {};
        this.rows = d.rows || [];
        this.total = d.total || 0;
      } catch (e) { this.rows = []; this.total = 0; }
    },
    reload() { this.page = 1; this.selected = null; this.load(); },
    onPage(p) { this.page = p; this.selected = null; this.load(); },
    onSize(s) { this.size = s; this.page = 1; this.selected = null; this.load(); },
    onPickCenter(c) { this.centerName = c.centerName; this.centerSearchOpen = false; this.reload(); },
    openAdd() { this.formMode = 'add'; this.formBranch = null; this.formOpen = true; },
    openEdit() { if (!this.selected) return; this.formMode = 'edit'; this.formBranch = { ...this.selected }; this.formOpen = true; },
    onSaved() { this.formOpen = false; this.reload(); }
  }
};
</script>

<style scoped>
.page { background: #fff; padding: 20px; border-radius: 8px; }
.page-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.page-head h3 { margin: 0; }
.head-btns button { padding: 7px 16px; border-radius: 5px; cursor: pointer; border: 1px solid #ccc; margin-left: 6px; }
.head-btns .primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.head-btns .ghost { background: #eef1f7; color: #33415c; }
.toolbar { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; margin-bottom: 14px; }
.toolbar label { font-size: 13px; color: #555; }
.toolbar input { padding: 7px 9px; border: 1px solid #d0d5dd; border-radius: 5px; }
.toolbar button { padding: 7px 16px; background: #2f6fed; color: #fff; border: none; border-radius: 5px; cursor: pointer; }
.toolbar button.srch { padding: 7px 12px; background: #eef4ff; color: #2f5fd0; border: 1px solid #2f6fed; font-size: 12px; }
.table-scroll { overflow-x: auto; }
.grid { width: 100%; border-collapse: collapse; }
.grid th, .grid td { border: 1px solid #e5e8ef; padding: 8px 10px; font-size: 13px; }
.grid th { background: #f0f3fa; color: #33415c; }
.grid th.c, .grid td.c { text-align: center; width: 60px; }
.grid tr.sel { background: #eaf1ff; }
.grid tbody tr:hover { background: #f6f9ff; cursor: pointer; }
.empty { text-align: center; color: #999; padding: 20px; }
</style>
